<ion-card
  class="add-invitation-space-view__container"
  (click)="customData !== 'summary' ? onToggleInvitationSpace($event) : ''"
  [ngClass]="{
    'add-invitation-space-view__container--added': spaceAdded,
    'add-invitation-space-view__container--summary': customData == 'summary',
    'add-invitation-space-view__container--no-border': customData == 'no-border'
  }"
>
  <ion-card-header class="add-invitation-space-view__title-container">
    <img
      *ngIf="!p.renderSmallMobile"
      [src]="
        row.image
          ? row.image.thumbnail
            ? row.image.thumbnail
            : row.image.filePath
          : '../../../assets/icons/room-plug.svg'
      "
      class="add-invitation-space-view__image"
    />
    <div class="add-invitation-space-view__details-container">
      <ion-card-title class="add-invitation-space-view__title">
        <img
          *ngIf="p.renderSmallMobile"
          [src]="
            row.image
              ? row.image.thumbnail
                ? row.image.thumbnail
                : row.image.filePath
              : '../../../assets/icons/room-plug.svg'
          "
          class="add-invitation-space-view__image"
        />
        <div
          class="display-flex ion-align-items-center ion-justify-content-between w-100"
        >
          <h2>
            {{ row.name }}
          </h2>
          <div
            class="ion-no-padding add-invitation-space-view__detail"
            *ngIf="showEquipmentsListButton"
          >
            <div
              class="options-button"
              size="small"
              (click)="presentPopover($event)"
            >
              <ion-icon slot="icon-only" name="star-outline"></ion-icon>
            </div>
          </div>
        </div>
      </ion-card-title>
      <ion-card-subtitle class="add-invitation-space-view__details">
        <div class="ion-no-padding add-invitation-space-view__detail">
          <ion-icon
            src="../../../assets/icons/building-alt.svg "
            class="add-invitation-space-view__icon"
          ></ion-icon>
          <ion-text class="add-invitation-space-view__detail-name">
            {{ row.floor?.building.name }}
          </ion-text>
        </div>
        <div
          class="ion-no-padding add-invitation-space-view__detail ion-justify-content-center"
        >
          <ion-icon
            name="code"
            class="add-invitation-space-view__icon rotate-90-deg"
          ></ion-icon>
          <ion-text class="add-invitation-space-view__detail-name">
            {{ row.floor?.name }} ({{ row.floor?.level }})
          </ion-text>
        </div>
        <div
          class="ion-no-padding add-invitation-space-view__detail ion-justify-content-center"
        >
          <ion-icon
            *ngIf="row.capacity"
            name="people-outline"
            class="add-invitation-space-view__icon"
          ></ion-icon>
          <ion-text
            class="add-invitation-space-view__detail-name"
            *ngIf="row.capacity"
          >
            {{ row.capacity }}
          </ion-text>
        </div>
      </ion-card-subtitle>
    </div>
  </ion-card-header>
</ion-card>
